export class ChangePasswordModalService {
  static $inject = ['$modal'];

  constructor(private $modal) { }

  changePassword() {
    const modalInstance = this.$modal.open({
      animation: true,
      template:
        '<change-password-modal modal-instance="modalInstance"></change-password-modal>',
      controller: [
        '$scope',
        '$modalInstance',
        function ($scope, $modalInstance) {
          $scope.modalInstance = $modalInstance;
        },
      ],
    });

    return modalInstance.result;
  }
}
